"use client";

import { renderByProcess } from "@/shared/render-by-process";
import CreditInsuranceSalePage from "./components/credit-insurance";
import LoanInsuranceSalePage from "./components/loan-insurance";
import {
	CreditCardInsuranceSaleContext,
	InsuranceSaleContext,
	LoanInsuranceSaleContext,
} from "./types";

interface Props {
	taskId: string;
	context: InsuranceSaleContext;
}

const InsuranceSalePage = ({ taskId, context }: Props) => {
	return renderByProcess<
		LoanInsuranceSaleContext,
		CreditCardInsuranceSaleContext
	>(context, {
		loan: (context) => <LoanInsuranceSalePage {...{ context, taskId }} />,
		credit: (context) => <CreditInsuranceSalePage {...{ context, taskId }} />,
	});
};

export default InsuranceSalePage;
